import { useState } from 'react';
import { supabase } from '../services/supabaseClient.js';

export function useFeedback() {
  const [reportOppId, setReportOppId] = useState(null);
  const [reportEmail, setReportEmail] = useState('');
  const [reportMessage, setReportMessage] = useState('');
  const [reportSending, setReportSending] = useState(false);
  const [reportSent, setReportSent] = useState(null);

  const [generalEmail, setGeneralEmail] = useState('');
  const [generalMessage, setGeneralMessage] = useState('');
  const [generalSending, setGeneralSending] = useState(false);
  const [generalSent, setGeneralSent] = useState(false);

  const sendGeneralFeedback = async () => {
    setGeneralSending(true);
    try {
      // Save to Supabase directly (reliable)
      const { error } = await supabase.from('feedback').insert({
        email: generalEmail,
        message: generalMessage,
        subject: 'General feedback',
        listing_id: 'general'
      });
      if (error) throw error;

      // Fire-and-forget email notification via API route
      fetch('/api/feedback', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: generalEmail,
          message: generalMessage,
          subject: 'General feedback',
        }),
      }).catch(() => {});

      setGeneralSent(true);
      setGeneralEmail('');
      setGeneralMessage('');
      setTimeout(() => setGeneralSent(false), 3000);
    } catch (err) {
      console.error('Failed to send feedback:', err.message);
      alert('Failed to send feedback. Please try again.');
    } finally {
      setGeneralSending(false);
    }
  };

  const sendReport = async (opp) => {
    setReportSending(true);
    const listingDetails = {
      make: opp.make,
      model: opp.model,
      version: opp.version,
      year: opp.year,
      fuelType: opp.fuelType,
      mileage: opp.mileage,
      sourcePrice: opp.sourcePrice,
      sourceCountry: opp.sourceCountry,
      targetCountry: opp.targetCountry,
      netProfit: opp.netProfit,
      transportCost: opp.transportCost,
      importTax: opp.importTax,
      co2: opp.co2,
      engineCC: opp.engineCC,
      sourceUrl: opp.sourceUrl
    };
    try {
      // Save to Supabase directly (reliable)
      const { error } = await supabase.from('feedback').insert({
        email: reportEmail,
        message: reportMessage,
        listing_id: opp.id,
        listing_details: listingDetails
      });
      if (error) throw error;

      // Fire-and-forget email notification via API route
      fetch('/api/feedback', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: reportEmail,
          message: reportMessage,
          subject: 'Listing feedback',
          listing_id: opp.id,
          listing_details: listingDetails,
        }),
      }).catch(() => {});

      setReportSent(opp.id);
      setReportEmail('');
      setReportMessage('');
      setTimeout(() => { setReportSent(null); setReportOppId(null); }, 3000);
    } catch (err) {
      console.error('Failed to send feedback:', err.message);
      alert('Failed to send feedback. Please try again.');
    } finally {
      setReportSending(false);
    }
  };

  return {
    reportOppId, setReportOppId,
    reportEmail, setReportEmail,
    reportMessage, setReportMessage,
    reportSending,
    reportSent, setReportSent,
    generalEmail, setGeneralEmail,
    generalMessage, setGeneralMessage,
    generalSending,
    generalSent,
    sendGeneralFeedback,
    sendReport,
  };
}
